import { Currency } from "./currency";

export enum PricingRuleKeys {
  PRICING_RULE_ID = "pricingRuleId",
  MIN_RANGE = "minRange",
  MAX_RANGE = "maxRange",
  PRICE = "price",
  BILLABLE_OPERATION_ID = "billableOperationId",
  CURRENCY = "currency",
  IS_LAST = "isLast",
  CURRENCY_CODE = "currencyCode",
  TRANSACTION_COST_EX_Tax = "transactionCostExTax",
  TRANSACTION_COST_IN_Tax = "transactionCostIncTax",
}

export interface PricingRuleCreateRequest {
  [PricingRuleKeys.MIN_RANGE]?: number;
  [PricingRuleKeys.MAX_RANGE]?: number;
  [PricingRuleKeys.PRICE]?: number;
  [PricingRuleKeys.BILLABLE_OPERATION_ID]?: string;
  [PricingRuleKeys.IS_LAST]: boolean;
  [PricingRuleKeys.CURRENCY]?: Currency;
  [PricingRuleKeys.CURRENCY_CODE]?: string;
}

export interface PricingRule {
  [PricingRuleKeys.PRICING_RULE_ID]: string;
  [PricingRuleKeys.MIN_RANGE]?: number;
  [PricingRuleKeys.MAX_RANGE]?: number;
  [PricingRuleKeys.PRICE]: number;
  [PricingRuleKeys.BILLABLE_OPERATION_ID]?: string;
  [PricingRuleKeys.CURRENCY]?: Currency;
  [PricingRuleKeys.TRANSACTION_COST_EX_Tax]?: number;
  [PricingRuleKeys.TRANSACTION_COST_IN_Tax]?: number;
}
